import Home from "views/Home"
import TourType from "views/TourType"
import Search from "views/Search"
import News from "views/News"
import NewsDetail from "views/NewsDetail"
import TourDetail from "views/TourDetail"

export const publicRouteData = [
    {
        element: <Home />,
        url: "/"
    },
    {
        element: <TourType />,
        url: "/tour-type/:slug"
    },
    {
        element: <Search />,
        url: "/search"
    },
    {
        element: <News />,
        url: "/news-category/:slug"
    },
    {
        element: <NewsDetail />,
        url: "/news/:slug"
    },
    {
        element: <TourDetail />,
        url: "/tour/:slug"
    }
]